<!-- begin::Body -->
<body *ngIf="!ForgotPassword"
	class="kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-header--fixed kt-header-mobile--fixed kt-subheader--enabled kt-subheader--fixed kt-subheader--solid kt-aside--enabled kt-aside--fixed kt-page--loading">

	<!-- begin:: Page -->
	<div class="kt-grid kt-grid--ver kt-grid--root">
		<div class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v4 kt-login--signin" id="kt_login">
			<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor fullheight"
				style="background-image: url(./../../../.././assets/media/bg/warehouseBlured.jpg); background-size:100%; height: 100vh !important;">
				<div class="kt-grid__item kt-grid__item--fluid kt-login__wrapper kt-padding-0" @LoginFade>
                        <div style="margin-top:20%;">
                    <div class="kt-portlet kt-portlet--mobile BackGroundConfig p-4 m-4">
					    <div class=" kt-login__container p-5">
						<div class="kt-login__logo" @LogoFade>
							<a href="javascript:void(0)">
								<img src="./../../../../assets/media/logos/Untitled-4-croped.png" width="200em">
							</a>
						</div>

						<div class="kt-login__signin">
							<div class="kt-login__head">
								<h3 class="kt-login__title">Sign in to Control Panel</h3>
							</div>

							<ngb-alert *ngIf="isLoggedError" type="danger" [dismissible]="false">
								<div class="alert-text">{{errorMsg}}</div>
							</ngb-alert>

								<form class="kt-form" [formGroup]="loginForm" (ngSubmit)="OnSubmit()">
									<div class="form-group kt-form__group row">
										<div class="col-md-12 kt-margin-bottom-20-mobile">
											<mat-form-field class="mat-form-field-fluid example-full-width">
												<input type="email" matInput placeholder="Email" formControlName="email" [required]="true" email>
												<mat-error>Email is
													<strong>required</strong>
												</mat-error>
											</mat-form-field>
										</div>
									</div> 
									<div class="form-group kt-form__group row">
										<div class="col-md-12 kt-margin-bottom-20-mobile">
											<mat-form-field class="mat-form-field-fluid example-full-width">
													<input  matInput placeholder="Password" formControlName="password"  [type]="HidePassword ? 'password' : 'text'" [required]="true">
													<button type="button" mat-icon-button matSuffix [matTooltip]="HidePassword ? 'Show password' : 'Hide password'" (click)="HidePassword = !HidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="HidePassword">
														<mat-icon>{{HidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
													</button>
												<mat-error>Password is
													<strong>required</strong>
												</mat-error>
											</mat-form-field>
										</div>
									</div> 
								
								<div class="kt-login__actions">
									<button class="text-dark" [hidden]="ShowSpinner" type="submit" mat-raised-button color="accent">
										Sign in
									</button>
									<div class="example-loading-shadebg" *ngIf="ShowSpinner">
										<mat-spinner class="example-margin m-auto" *ngIf="ShowSpinner" color="accent" [diameter]="30"></mat-spinner>
									</div>
								</div>
								<div class="row mt-5">
									<p class="m	l-auto text-primary CustomCursor" (click)="IForgotPassword()">Forgot Password ?</p>
								</div>
							</form>
						</div>
						
                    </div>
                </div>
                </div>
				</div>
			</div>
		</div>
	</div>
</body>
<!-- end::Body -->

<!-- begin::Body -->
<body *ngIf="ForgotPassword"
	class="kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-header--fixed kt-header-mobile--fixed kt-subheader--enabled kt-subheader--fixed kt-subheader--solid kt-aside--enabled kt-aside--fixed kt-page--loading">

	<!-- begin:: Page -->
	<div class="kt-grid kt-grid--ver kt-grid--root">
		<div class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v4 kt-login--signin" id="kt_login">
			<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor fullheight"
				style="background-image: url(./../../../.././assets/media/bg/warehouseBlured.jpg); 
					   background-size:cover;">
				<div class="kt-grid__item kt-grid__item--fluid kt-login__wrapper kt-padding-0" @LoginFade>
                        <div style="margin-top:20%;">
                    <div class="kt-portlet kt-portlet--mobile BackGroundConfig p-4 m-4">
					    <div class="kt-login__container p-5">
						<div class="kt-login__logo" @LogoFade>
							<a href="javascript:void(0)">
								<img src="./../../../../assets/media/logos/etloob-logo.svg" width="200em">
							</a>
						</div>

						<div class="kt-login__signin">
							<div class="kt-login__head">
								<h3 class="kt-login__title">Forgotten Password ?</h3>
							</div>
							<p class="kt-login__title text-center">Enter your email to reset your password</p>

							<form class="kt-form mt-5" [formGroup]="ForgotPasswordForm">
								<div class="form-group kt-form__group row">
									<div class="col-md-12 kt-margin-bottom-20-mobile">
										<mat-form-field class="mat-form-field-fluid example-full-width">
											<input type="email" matInput placeholder="Email" formControlName="email" [required]="true" email>
											<mat-error>Email is
												<strong>required</strong>
											</mat-error>
										</mat-form-field>
									</div>
								</div> 
								
								<div class="kt-login__actions">
									<p> {{ForgotPasswordPlaceHolder}}  </p>
									<button class="text-dark" [hidden]="ShowSpinner" type="submit" mat-raised-button color="accent" (click)="OnSubmitForgotPassword('byPhone')">
										<mat-icon class="p-1">phone</mat-icon>	Phone Number 
									</button>
									<button class="text-dark" [hidden]="ShowSpinner" type="submit" mat-raised-button color="accent" (click)="OnSubmitForgotPassword('byMail')">
										<mat-icon class="p-1">email</mat-icon>	Email
									</button>
									<div class="example-loading-shadebg" *ngIf="ShowSpinner">
										<mat-spinner class="example-margin m-auto" *ngIf="ShowSpinner" color="accent" [diameter]="30"></mat-spinner>
									</div>
								</div>
								<div class="row mt-5">
									<p class="m	l-auto text-primary CustomCursor" (click)="BacktoLogin()">Back to login</p>
								</div>
							</form>
						</div>
						
                    </div>
                </div>
                </div>
				</div>
			</div>
		</div>
	</div>
</body>
<!-- end::Body -->